import { useMemo } from 'react';
import { customPartnerThemePaletteConfig } from '../config/customPartnerThemePaletteConfig';
import { CustomThemePalette } from './CustomThemePalette';

interface IWLTheme {
    affId?: string;
}

export const CustomPartnerThemePalette = ({ affId }: IWLTheme) => {
    const customThemePaletteStyles = useMemo(() => (affId ? customPartnerThemePaletteConfig[affId] : null), [affId]);

    if (customThemePaletteStyles) {
        return <CustomThemePalette styles={customThemePaletteStyles} />;
    }

    return null;
};
